import React, {ReactElement} from 'react'
import styled from 'styled-components'
import {format} from 'date-fns'
import {useWindowMode} from 'windows'
import {Paragraph} from 'common/components'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const StyledContentContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`

const StyledRightSection = styled.div`
  text-align: right;
`

export default function DropboxUploadSuccess({
  total,
  totalDuplicates,
  totalFailed,
  totalSuccess,
  renderNewUpload,
}: {
  total: number
  totalDuplicates: number
  totalFailed: number
  totalSuccess: number
  renderNewUpload(): ReactElement
}) {
  const mode = useWindowMode()

  return (
    <StyledContainer>
      <StyledContentContainer>
        <div>
          <Paragraph fontSize="m" fontWeight="bold" color="gray_5">
            {format(new Date(), 'eeee, d MMM yyyy')}
          </Paragraph>
          <Paragraph fontSize="l" fontWeight="bold">
            {`${total} Contents`}
          </Paragraph>
          <Paragraph fontWeight="bold" color="success_5">
            {`${totalSuccess} Success`}
          </Paragraph>
        </div>
        <StyledRightSection>
          <Paragraph fontWeight="bold" color="danger_5">
            {`${totalFailed} Failed`}
          </Paragraph>
          <Paragraph fontWeight="bold" color="warning_4">
            {`${totalDuplicates} Duplicates`}
          </Paragraph>
        </StyledRightSection>
      </StyledContentContainer>
      {mode === 'website' && renderNewUpload()}
    </StyledContainer>
  )
}
